import HttpService from './HttpService';
import {TIMINGS_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';

const _axios = HttpService.getAxiosClient();

export const getConsolidatedTimings = async (userId, startDate, endDate) => {
  try {
    const response = await _axios.get(
      `${TIMINGS_PATH}/consolidated?userId=${userId}&startDate=${startDate}&endDate=${endDate}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getRawTimings = async (userId, consolidatedDate) => {
  try {
    const response = await _axios.get(
      `${TIMINGS_PATH}/timings/raw/user/${userId}?date=${consolidatedDate}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getHolidays = async (startDate, endDate) => {
  try {
    const response = await _axios.get(
      `${TIMINGS_PATH}/holidays?startDate=${startDate}&endDate=${endDate}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getSummary = async (startDate, endDate, empId) => {
  try {
    const response = await _axios.get(
      `${TIMINGS_PATH}/consolidated/${empId}/summary?startDate=${startDate}&endDate=${endDate}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const deleteLogTime = async (empId) => {
  try {
    const response = await _axios.put(
      `${TIMINGS_PATH}/timings/raw/user/${empId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
const add_URL = `${TIMINGS_PATH}/timings/raw/user/addRawTiming`;
export const addLogTime = async (newLogTime) => {
  try {
    const response = await _axios.post(add_URL, newLogTime);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
export const getConsolidatedTimingsWithFlag = async (
  pageSize,
  pageNumber,
  userId,
  filters,
) => {
  try {
    const response = await _axios.get(
      `${TIMINGS_PATH}/consolidated?flag=true&pageSize=${pageSize}&pageNumber=${pageNumber}${
        filters.startDate ? '&startDate=' + filters.startDate : ''
      }${filters.endDate ? '&endDate=' + filters.endDate : ''}${
        userId ? '&userId=' + userId : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
export const removeFlagConsolidatedTimings = async (endDate, userId, flag) => {
  try {
    const response = await _axios.put(
      `${TIMINGS_PATH}/consolidated?endDate=${endDate}&userId=${userId}&flag=${flag}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
